import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import { Clear } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  fileContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '5px 10px',
    borderRadius: 4,
    color: '#333',
    border: '1px solid #ddd',
    backgroundColor: '#f9f9f9',
    alignSelf: 'flex-start'
  },
  fileName: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingRight: '10px',
    marginTop: '2px'
  },
  clearButton: {
    width: '24px',
    height: '24px',
    marginRight: '10px',
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    borderRadius: '50%',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  }
}));

const FileNameConatiner = ({ fileName, isUploading, onClearFile }) => {
  const classes = useStyles();

  return (
    <div>
      {fileName && (
        <div className={classes.fileContainer}>
          <IconButton
            className={classes.clearButton}
            onClick={onClearFile}
            disabled={isUploading}
          >
            <Clear fontSize="small" />
          </IconButton>
          <span className={classes.fileName}>{fileName}</span>
        </div>
      )}
    </div>
  );
};

export default FileNameConatiner;
